var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../common/http.service';
import { HttpClient } from '@angular/common/http';
var ReportsService = /** @class */ (function () {
    function ReportsService(httpService, http) {
        this.httpService = httpService;
        this.http = http;
    }
    ReportsService.prototype.Ontime = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/ontime', data);
    };
    ReportsService.prototype.TaskDuration = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/driverlog', data);
    };
    ReportsService.prototype.taskComplete = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/taskcomplete', data);
    };
    ReportsService.prototype.merchantpagetaskComplete = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/merchantpagetaskcomplete', data);
    };
    ReportsService.prototype.taskCompleteDetailDownload = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/taskcomplete/detail/download', data);
    };
    ReportsService.prototype.merchantpagetaskCompleteDetailDownload = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/merchantpagetaskcomplete/detail/download', data);
    };
    ReportsService.prototype.driverLogDetailDownload = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/driverlog/detail/download', data);
    };
    ReportsService.prototype.agentRatingDetailDownload = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/driverrating/detail/download', data);
    };
    ReportsService.prototype.pricingandearning = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/pricingandearning', data);
    };
    ReportsService.prototype.TopAgent = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/topagent', data);
    };
    ReportsService.prototype.DriverRating = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/driverrating', data);
    };
    ReportsService.prototype.merchantPricing = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/merchantpricing', data);
    };
    ReportsService.prototype.merchantpagePricing = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/merchantpagepricing', data);
    };
    ReportsService.prototype.driverearning = function (data) {
        // console.log(data);
        return this.httpService.get('/analytics/driverdetails', data);
    };
    ReportsService.prototype.listTemplate = function () {
        return this.httpService.get('/customfields', null);
    };
    ReportsService.prototype.getTemplateReports = function (data) {
        return this.httpService.get('/analytics/template', data);
    };
    ReportsService.prototype.handleError = function (error) {
        return Observable.throw(error);
    };
    ReportsService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpService, HttpClient])
    ], ReportsService);
    return ReportsService;
}());
export { ReportsService };



//////////////////
// WEBPACK FOOTER
// ./src/app/report/reports.service.ts
// module id = ./src/app/report/reports.service.ts
// module chunks = main